/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentAvailability } from './AppointmentAvailability';
import {
    AppointmentAvailabilityFromJSON,
    AppointmentAvailabilityFromJSONTyped,
    AppointmentAvailabilityToJSON,
    AppointmentAvailabilityToJSONTyped,
} from './AppointmentAvailability';
import type { AttendanceType } from './AttendanceType';
import {
    AttendanceTypeFromJSON,
    AttendanceTypeFromJSONTyped,
    AttendanceTypeToJSON,
    AttendanceTypeToJSONTyped,
} from './AttendanceType';

/**
 * 
 * @export
 * @interface MultiDayAttendanceEntryRequest
 */
export interface MultiDayAttendanceEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof MultiDayAttendanceEntryRequest
     */
    purposeKey: string;
    /**
     * 
     * @type {AttendanceType}
     * @memberof MultiDayAttendanceEntryRequest
     */
    attendanceType: AttendanceType;
    /**
     * 
     * @type {AppointmentAvailability}
     * @memberof MultiDayAttendanceEntryRequest
     */
    availability: AppointmentAvailability;
    /**
     * 
     * @type {string}
     * @memberof MultiDayAttendanceEntryRequest
     */
    details: string | null;
    /**
     * 
     * @type {string}
     * @memberof MultiDayAttendanceEntryRequest
     */
    substituteCounselorId: string | null;
}



/**
 * Check if a given object implements the MultiDayAttendanceEntryRequest interface.
 */
export function instanceOfMultiDayAttendanceEntryRequest(value: object): value is MultiDayAttendanceEntryRequest {
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('attendanceType' in value) || value['attendanceType'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('substituteCounselorId' in value) || value['substituteCounselorId'] === undefined) return false;
    return true;
}

export function MultiDayAttendanceEntryRequestFromJSON(json: any): MultiDayAttendanceEntryRequest {
    return MultiDayAttendanceEntryRequestFromJSONTyped(json, false);
}

export function MultiDayAttendanceEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiDayAttendanceEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'purposeKey': json['purposeKey'],
        'attendanceType': AttendanceTypeFromJSON(json['attendanceType']),
        'availability': AppointmentAvailabilityFromJSON(json['availability']),
        'details': json['details'],
        'substituteCounselorId': json['substituteCounselorId'],
    };
}

export function MultiDayAttendanceEntryRequestToJSON(json: any): MultiDayAttendanceEntryRequest {
    return MultiDayAttendanceEntryRequestToJSONTyped(json, false);
}

export function MultiDayAttendanceEntryRequestToJSONTyped(value?: MultiDayAttendanceEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purposeKey': value['purposeKey'],
        'attendanceType': AttendanceTypeToJSON(value['attendanceType']),
        'availability': AppointmentAvailabilityToJSON(value['availability']),
        'details': value['details'],
        'substituteCounselorId': value['substituteCounselorId'],
    };
}

